import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=86de4952&"
import script from "./AppLayout.js?vue&type=script&lang=js&"
export * from "./AppLayout.js?vue&type=script&lang=js&"
import style0 from "./AppLayout.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VAppBar,VMain})
